import { useYardContext } from "@/providers/yard-context";
import { StatsVisasSuivi } from "./stats-visas-suivi";
import { StatsVisasTravaux } from "./stats-visas-travaux";

// Écran « Stats visas » : la variante dépend du type de contrat de la société
// de l'utilisateur. Contrats de suivi (écran 026, MOE / CT / AMO / SPS)
// → StatsVisasSuivi ; entreprises de travaux rang 1 (écran 013)
// → StatsVisasTravaux.

const OVERSIGHT_CONTRACT_TYPES = ["moe", "ct", "amo", "sps"];

export function StatsVisas() {
  const { hasContractType } = useYardContext();

  if (OVERSIGHT_CONTRACT_TYPES.some((type) => hasContractType(type))) {
    return <StatsVisasSuivi />;
  }

  return <StatsVisasTravaux />;
}
